export const defaultUserData: any = {
  userId: '',
  firstName: '',
  lastName: '',
  email: '',
  phoneNumberr: '',
  countryCode: '',
  country: '',
  city: '',
  birthDay: new Date(),
  userType: '',
  caneId: '',
  isAssistant: false,
  assistantRegion: '',
  consultSeconds: 0,
  addConsultMinutes: 0,
  consultExpiresDate: new Date(Date.now() + 30 * 86400000) // 30 days from now
}
